import React from 'react'
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';

export const FormAntibiotic = (props) => {

    const {
        closeDialog, loading, handleInputChange, validaciones, methodAction, antibiotic, button, aware
    } = props;

    const {
        antibiotic_valid
    } = validaciones;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className="col-form-label">Antibiótico <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                className="form-control form-control-sm input-air-primary"
                                name="antibiotic"
                                onChange={handleInputChange}
                                value={antibiotic}
                                autoComplete="off"
                                invalid={antibiotic_valid}
                            />
                            <FormFeedback>Minimo 1 caracter</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label className="col-form-label">AWARE</Label>
                            <Input
                                type="select"
                                className="input-admision"
                                name="aware"
                                value={aware}
                                autoComplete="off"
                                onChange={handleInputChange}
                            >

                                <option value="">Seleccione una opción</option>
                                <option value="1">A</option>
                                <option value="2">W</option>
                                <option value="3">R</option>
                                {/* <option value="4">SIN AWARE</option> */}

                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" type="submit" size="sm" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" color='danger' type="button" onClick={closeDialog}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}
